import React from 'react'
import { DashboardLayout } from '../../layouts'
import { Redirect } from 'react-router-dom'
import { MainContent, MainContentSuperadmin } from './components'
import { Button } from '../../components'
import auth from '../../utils/auth'

const Dashboard = () => {
  const { isOfficial, isSuperadmin } = auth()

  return (isOfficial || isSuperadmin) ? (
    <DashboardLayout>
      <div className="flex flex-wrap justify-between items-center mb-5 lg:mb-10">
        <h1 className="hidden xl:w-auto xl:block text-4xl font-bold font-primary">
          Dashboard
        </h1>
        {
          isOfficial &&
          <div className="w-full xl:w-auto flex items-center flex-col md:flex-row md:mt-5 xl:mt-0">
            <p
              className="font-bold flex-1 lg:font-normal lg:text-sm text-center md:text-left mt-5 md:mt-0 mb-3 md:mb-0 mx-auto lg:mr-3"
              style={{fontSize: '11px'}}
            >
              Download Organization Profile
            </p>
            <div className="w-full md:w-1/2 lg:w-auto md:flex items-center">
              <Button thin className="px-5 mb-3 md:mr-2 md:mb-0">
                <span className="font-primary normal-case whitespace-no-wrap" style={{fontSize: '11px'}}>Profile - English Version</span>
              </Button>
              <Button thin className="px-5">
                <span className="font-primary normal-case whitespace-no-wrap" style={{fontSize: '11px'}}>Profile - Indonesia Version</span>
              </Button>
            </div>
          </div>
        }
      </div>
      {
        isOfficial &&
        <MainContent />
      }
      {
        isSuperadmin &&
        <MainContentSuperadmin />
      }
    </DashboardLayout>
  ) : <Redirect to="/dashboard/profile"/>
}

export { Dashboard }
